import { useState, useEffect } from 'react';
import type { Position } from '../types';
import { applyTransform } from '../utils';

export const useMovement = (
  wrapperRef: React.RefObject<HTMLDivElement>,
  width: number,
  height: number,
) => {
  const [center, setCenter] = useState<Position>({ x: 0, y: 0 });

  useEffect(() => {
    const el = wrapperRef.current;
    if (!el) {
      return;
    }
    applyTransform(el, center, width, height);
  }, [center, width, height, wrapperRef]);

  return {
    center,
    setCenter,
  };
};
